import React from 'react';
import { NextPage, NextPageContext } from 'next';
import Router from 'next/router';
import { Page } from 'shared-types/Common';

import Markdown from '@common/components/Markdown';
import SectionContainer from '@common/components/SectionContainer';

import * as entityActions from '@store/entity/actions';
import { NormalizedStore } from '@store/entity/entity.types';
import { entitySelectors } from '@store/entity/selectors';

type CancellationPolicyProps = {
  page: Page;
};

type CancellationPolicyInitialProps = {
  store: NormalizedStore;
  language: string;
} & NextPageContext;

const CancellationPolicy: NextPage<CancellationPolicyProps> = ({ page }) => {
  if (!page) {
    return null;
  }

  return (
    <SectionContainer>
      <h2>{page.title}</h2>
      <Markdown text={page.content} />
    </SectionContainer>
  );
};

CancellationPolicy.getInitialProps = async ({
  store,
  property,
  language,
  res,
}: CancellationPolicyInitialProps): Promise<CancellationPolicyProps> => {
  await entityActions.fetchCancellationPage(property.id, language)(store.dispatch);

  const page = entitySelectors.getPage(store.getState(), 'cancellation');
  if (!page) {
    if (res) {
      res.writeHead(302, {
        Location: '/',
      });
      res.end();
    } else {
      Router.push('/');
    }
  }

  return {
    page,
  };
};

export default CancellationPolicy;
